export default class Dyngraph2PNG {
    private _image: HTMLImageElement = null;
    private _dygraph: Dygraph;
    private ctx: CanvasRenderingContext2D = null;
    private options: DygraphExportOptions = {
        fontSize: 16,
        yMarginLeft: 10,
        debug: false
    };

    private canvas: HTMLCanvasElement = null;

    public get image() {
        return this._image;
    }

    constructor(dygraph: Dygraph, options: DygraphExportOptions = null) {
        const _this = this;
        const canvas: HTMLCanvasElement = dygraph.maindiv_.querySelectorAll('canvas')[0];
        const fontSize = options?.fontSize || _this.options.fontSize;

        _this.canvas = document.createElement('canvas');
        _this.ctx = _this.canvas.getContext('2d');
        _this._dygraph = dygraph;
        _this._image = document.createElement('img');
        _this.canvas.height = options?.height || canvas.height;
        _this.canvas.width = options?.width || canvas.width;
        _this.ctx.font = fontSize + 'px arial';
        _this.ctx.globalCompositeOperation = 'destination-over';

        const axisPlugin = _this.getPlugin('Axes Plugin');

        _this.drawYLabels(axisPlugin);
        _this.drawXLabels(axisPlugin);

        _this.ctx.drawImage(<any>canvas, 0, 0);
        _this._image.src = _this.canvas.toDataURL();

        // debug only
        if (_this.options.debug) {
            _this._image.classList.add('debug');
            document.body.insertAdjacentElement('beforeend', _this._image);
        }
    }

    /**
     * draw vertical labels
     * @param plugin
     */
    private drawYLabels(plugin: DygraphPlugin) {
        let ticks = Math.ceil(this.canvas.height / plugin.ylabels_.length);
        for (let i = 0; i < plugin.ylabels_.length; i++) {
            let label: HTMLDivElement = plugin.ylabels_[i];
            this.ctx.fillText(
                label.innerText,
                this.options.yMarginLeft,
                this.canvas.height - ticks * (i + 1) + this.options.fontSize
            );
        }
    }
    /**
     * draw horizontal labels
     * @param plugin
     */
    private drawXLabels(plugin: DygraphPlugin) {
        let ticks = Math.ceil((this.canvas.width - 180) / plugin.xlabels_.length);
        for (let i = 0; i < plugin.xlabels_.length; i++) {
            let label: HTMLDivElement = plugin.xlabels_[i];
            this.ctx.fillText(
                label.innerText,
                (ticks + i * 1.4) * (i + 1),
                this.canvas.height - 20
            );
        }
    }

    /**
     *
     * @param pluginName string
     * @returns DygraphPlugin
     */
    private getPlugin(pluginName: string) {
        for (let i = 0; i < this._dygraph.plugins_.length; i++) {
            if (this._dygraph.plugins_[i].plugin.toString() == pluginName) {
                return <DygraphPlugin>this._dygraph.plugins_[i].plugin;
            }
        }
    }
}
